export default __webpack_public_path__ + "static/media/kaggle.699e845f.png";